import React from 'react';
import { Core } from './core/Core';
import RouteProvider from './app/components/RouteProvider/RouteProvider';

const App = () => {
  return <Core routeProvider={<RouteProvider />}></Core>;
};

export default App;
